const styles = (theme) => ({
  root: {
    ...theme.mixins.modal.dialog.root,
    overflowY: 'scroll',
  },
  departmentRow: {
    marginBottom: 0,
  },
});
export default styles;
